import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_SHIP_ID } from 'routes/availability-planning/-searchParams'
import { Route as NewRoute } from 'routes/availability-planning/index'

export const Route = createFileRoute(
  '/availability-planning/(deprecated_routes)/$siteID/$shipID'
)({
  beforeLoad: ({ params }) => {
    const { siteID, shipID } = params
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: siteID,
        [SEARCH_PARAM_SHIP_ID]: shipID,
      }),
      replace: true,
    })
  },
})
